// extracted by mini-css-extract-plugin
export var deliveryRow = "_s9-a";
export var fixedHeight = "_s9-4";
export var freightLogo = "_s9-9";
export var fullWidth = "_s9-3";
export var priceColumn = "_s9-5";
export var radioSelected = "_s9-7";
export var radioUnselected = "_s9-6";
export var selectedOption = "_s9-2";
export var selectedOptionContainer = "_s9-1";
export var selection = "_s9-0";
export var tallSkeletonText = "_s9-8";